import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'; import { HttpService } from '@core/shared';
import {
    UrlBuilder,
    GET_TDS_APP_TOKEN,
    GET_TDS_REWARD_TYPES,
    GET_TDS_ORDER_STATUSES,
    GET_TDS_REPORTS,
    GET_DOWNLOAD_TDS_REPORT

} from '@core/core-api-variables';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TDSReportService {
    private tdsAPPAPIOrigin = "https://compliance-qa.channelsmart.net/v1/";

    constructor(public httpService: HttpService, private http: HttpClient) { }
    getTDSAppToken(): Observable<any> {
        return this.httpService.get(GET_TDS_APP_TOKEN).pipe(map((res: any) => {
            return res;
        }))
    }
    getRewardTypes(token: string): Observable<any> {
        return this.http.get(this.tdsAPPAPIOrigin + GET_TDS_REWARD_TYPES, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Nexus-Environment-Key': environment.environmentKey,
                'ClientId': "1ac7c35a-264e-4e3e-83a8-1ecf4304df8b"
            }
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    getOrderStatuses(token: string): Observable<any> {
        return this.http.get(this.tdsAPPAPIOrigin + GET_TDS_ORDER_STATUSES, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Nexus-Environment-Key': environment.environmentKey,
                'ClientId': "1ac7c35a-264e-4e3e-83a8-1ecf4304df8b"
            }
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    getReports(token: string, payload): Observable<any> {
        let url = UrlBuilder(this.tdsAPPAPIOrigin + GET_TDS_REPORTS, payload);
        return this.http.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Nexus-Environment-Key': environment.environmentKey,
                'ClientId': "1ac7c35a-264e-4e3e-83a8-1ecf4304df8b"
            }
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    getDownloadReports(token: string, payload): Observable<any> {
        let url = UrlBuilder(this.tdsAPPAPIOrigin + GET_DOWNLOAD_TDS_REPORT, payload);

        return this.http.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Nexus-Environment-Key': environment.environmentKey,
                'ClientId': "1ac7c35a-264e-4e3e-83a8-1ecf4304df8b",
            },
            responseType: 'text' as 'json'
        }).pipe(
            map((response: any) => {
                console.log("CSV Response:", response);
                return response;
            }, (err) => {
                return err;
            })
        );
    }

}
